// Built-in shape presets (percent coordinates in a 100x100 box).
export type ShapeId =
  | "rectangle"
  | "circle"
  | "triangle"
  | "star"
  | "pentagon"
  | "octagon"
  | "rhombus"
  | "heart"
  | "crescent"
  | "kite"
  | "oval"
  | "semicircle";

export type ShapePreset =
  | { kind: "rect" }
  | { kind: "circle" }
  | { kind: "polygon"; points: { x: number; y: number }[] }
  | { kind: "path"; d: string; fillRule?: "nonzero" | "evenodd" };

export const SHAPE_IDS: ShapeId[] = [
  "rectangle",
  "circle",
  "triangle",
  "star",
  "pentagon",
  "octagon",
  "rhombus",
  "heart",
  "crescent",
  "kite",
  "oval",
  "semicircle"
];

export const SHAPE_PRESETS: Record<ShapeId, ShapePreset> = {
  rectangle: { kind: "rect" },
  circle: { kind: "circle" },
  triangle: {
    kind: "polygon",
    points: [{ x: 50, y: 0 }, { x: 100, y: 100 }, { x: 0, y: 100 }]
  },
  rhombus: {
    kind: "polygon",
    points: [{ x: 50, y: 0 }, { x: 100, y: 50 }, { x: 50, y: 100 }, { x: 0, y: 50 }]
  },
  pentagon: {
    kind: "polygon",
    points: [{ x: 50, y: 0 }, { x: 100, y: 38 }, { x: 81, y: 100 }, { x: 19, y: 100 }, { x: 0, y: 38 }]
  },
  octagon: {
    kind: "polygon",
    points: [
      { x: 30, y: 0 }, { x: 70, y: 0 },
      { x: 100, y: 30 }, { x: 100, y: 70 },
      { x: 70, y: 100 }, { x: 30, y: 100 },
      { x: 0, y: 70 }, { x: 0, y: 30 }
    ]
  },
  star: {
    kind: "polygon",
    points: [
      { x: 50, y: 0 }, { x: 61, y: 35 }, { x: 98, y: 35 }, { x: 68, y: 57 }, { x: 79, y: 91 },
      { x: 50, y: 70 }, { x: 21, y: 91 }, { x: 32, y: 57 }, { x: 2, y: 35 }, { x: 39, y: 35 }
    ]
  },
  // Heart with deeper top notch (100x100 viewBox).
  heart: {
    kind: "path",
    d: "M50 92 C22 74 10 58 10 38 C10 20 24 10 38 10 C46 10 49 16 50 22 C51 16 54 10 62 10 C76 10 90 20 90 38 C90 58 78 74 50 92 Z"
  },
  // Crescent as a single closed path (no evenodd needed).
  crescent: {
    kind: "path",
    d: "M77.20 22.94 A35 35 0 1 0 77.20 77.06 A28 28 0 1 1 77.20 22.94 Z"
  },
  // Kite as polygon in percent coordinates.
  kite: {
    kind: "polygon",
    points: [{ x: 50, y: 0 }, { x: 86, y: 40 }, { x: 50, y: 100 }, { x: 14, y: 40 }]
  },
  // Oval (path) in 100x100 viewBox.
  oval: {
    kind: "path",
    d: "M50 15 A40 30 0 1 0 50 85 A40 30 0 1 0 50 15 Z"
  },
  // Semicircle (flat bottom) in 100x100 viewBox.
  semicircle: {
    kind: "path",
    d: "M10 60 A40 40 0 0 1 90 60 L90 100 L10 100 Z"
  }
};
